import Vue from 'vue'
import store from '../store'

Vue.filter('formatRequestedDelivery', (value, dateStyle, timeStyle) => {
  if (!value) {
    return value
  }

  const [date, time] = value.split(' ')

  if (time) {
    return Vue.filter('timezone')(value, dateStyle, timeStyle)
  }

  return new Date(date).toLocaleDateString(store.getters.locale)
})
